import React, { FC, useState, useEffect, useRef } from 'react';

import { Modal } from 'components/modal';
import { ChoosePaymentMethod } from 'components/payments/ChoosePaymentMethod';
import * as Types from 'types';
import { getErrorMessage, errorFromException } from 'errors';

import { placeBidUsingPaymentMethod } from './helpers';

type Props = {
  userId?: number;
};

export const ChooseBidPaymentMethod: FC<Props> = ({ userId }) => {
  const [bidPublicId, setBidPublicId] = useState<string | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSuccessCallback = useRef<(bidState: Types.BidState) => void>();
  const onFailureCallback = useRef<(errorMessage: string) => void>();

  useEffect(() => {
    window.ReactTradeApp = window.ReactTradeApp ?? {};
    window.ReactTradeApp.showBidPaymentForm = (bidPublicId, onSuccess, onFailure) => {
      setBidPublicId(bidPublicId);
      onSuccessCallback.current = onSuccess;
      onFailureCallback.current = onFailure;
    };
  }, []);

  const onSuccess = (bidState: Types.BidState) => {
    setBidPublicId(undefined);
    onSuccessCallback.current?.(bidState);
  };

  const cancel = () => {
    setBidPublicId(undefined);
  };

  return (
    <div>
      {userId && (
        <Modal
          isOpen={!!bidPublicId}
          onRequestClose={cancel}
          styleContentWrapper={{ paddingTop: 0 }}
          variant='wide'
          closeDisabled={isSubmitting ? 'Please wait until current operation finishes' : undefined}
        >
          <div className='container-fluid px-0'>
            <ChoosePaymentMethod
              returnUrl={window.location.href}
              userId={userId}
              classNameTitle='choose-payment-method__title'
              style={{ minHeight: 236 }}
              onSubmittingStateChange={setIsSubmitting}
              onContinueUsingPayment={async (paymentMethodId) => {
                try {
                  if (!bidPublicId) {
                    throw 'Unknown bid';
                  }

                  const { data, error } = await placeBidUsingPaymentMethod(
                    bidPublicId,
                    paymentMethodId,
                  );

                  if (error || !data) {
                    throw error;
                  } else {
                    onSuccess(data.state);
                    return { data: {}, error: undefined };
                  }
                } catch (e) {
                  bugsnag.notify(getErrorMessage(e));
                  return errorFromException(e);
                }
              }}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
